import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { CSSVariables, FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Markierung({ color }: { color: string | null }) {
  return (
    <FontAwesomeIcon
      icon={faCircle}
      size="xs"
      className={`text-(--dot-color)`}
      style={
        {
          '--dot-color': color,
        } as React.CSSProperties & CSSVariables
      }
    />
  );
}
